// extracted by mini-css-extract-plugin
export default {"root":"IconUpload_root__f1RrN"};